// extracted by mini-css-extract-plugin
export default {"image":"Image__image--slots-gXjYq","loaded":"Image__loaded--slots-YtSLV"};